import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import apiMiddleware from './apiMiddleware';
import thunk from "redux-thunk";
import { draft } from './draft';
import { user } from './user';
import { timecard } from './timecard';
import { playlist } from './playlist';
import { entry } from './entry';
import { api, API } from './api';
import { message } from './message';
import { general } from './general';
import { incidents } from './incidents';
import { tasks } from './tasks';
import { totals } from './totals';
import { calendar } from './calendar';
import { receipt } from './receipt';
import kpiDetails from './kpiDetails';

// Replace functions / FormData so API actions aren't opaque blobs in DevTools
const actionSanitizer = (action) => {
  if (action.type !== API || !action.payload) return action;
  const { onSuccess, onFailure, formData, ...rest } = action.payload;
  return {
    ...action,
    payload: {
      ...rest,
      onSuccess: onSuccess ? '<fn>' : null,
      onFailure: onFailure ? '<fn>' : null,
      formData: formData ? '<FormData>' : null,
    },
  };
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    trace: true,
    traceLimit: 25,
    actionSanitizer,
  })
  : compose;

const store = createStore(
  combineReducers({
    api,
    timecard,
    totals,
    playlist,
    draft,
    user,
    incidents,
    tasks,
    entry,
    message,
    general,
    calendar,
    kpiDetails,
    receipt
  }),
  composeEnhancers(applyMiddleware(thunk, apiMiddleware))
);
window.store = store;
export default store;